import { buttonClass } from "../../manageLead/shared";

export function ActionGrid({
  children,
}) {
  return (
    <div className="grid grid-cols-2 gap-2">
      {children}
    </div>
  );
}

export function ActionButton({
  children,
  onClick,
  disabled,
  full = false,
}) {
  return (
    <button
      type="button"
      disabled={disabled}
      onClick={onClick}
      className={`rounded-xl border border-slate-200 bg-white px-2.5 py-2.5 text-[11px] font-semibold leading-4 text-slate-700 transition hover:border-slate-400 hover:bg-slate-50 disabled:cursor-not-allowed disabled:opacity-40 sm:px-3 sm:py-3 sm:text-sm ${
        full
          ? "col-span-2"
          : ""
      }`}
    >
      {children}
    </button>
  );
}

export function QuickButton({
  children,
  onClick,
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      className="rounded-lg border border-slate-200 px-2 py-2 text-[10px] font-medium leading-4 transition hover:border-slate-400 sm:text-xs"
    >
      {children}
    </button>
  );
}

export function FormActions({
  updating,
  submitText,
  onCancel,
}) {
  return (
    <div className="grid grid-cols-2 gap-2 pt-1">
      <button
        type="button"
        disabled={updating}
        onClick={onCancel}
        className="rounded-xl border border-slate-200 px-3 py-2.5 text-xs font-medium text-slate-600 sm:text-sm"
      >
        Cancel
      </button>

      <button
        type="submit"
        disabled={updating}
        className={`${buttonClass} py-2.5 text-xs sm:text-sm`}
      >
        {updating
          ? "Saving..."
          : submitText}
      </button>
    </div>
  );
}

export function Label({
  children,
}) {
  return (
    <label className="mb-1 block text-[11px] font-medium text-slate-500">
      {children}
    </label>
  );
}

export function ReadonlyRow({
  label,
  value,
}) {
  return (
    <div className="rounded-lg bg-slate-50 px-3 py-2">
      <p className="text-[10px] uppercase tracking-wide text-slate-400">
        {label}
      </p>

      <p className="text-sm font-medium">
        {value || "—"}
      </p>
    </div>
  );
}

export function MiniNotice({
  children,
}) {
  return (
    <div className="mb-3 rounded-lg bg-slate-50 px-3 py-2 text-xs text-slate-600">
      {children}
    </div>
  );
}

export function StatusNotice({
  title,
  text,
}) {
  return (
    <div className="rounded-xl bg-slate-50 px-4 py-4 text-center">
      <p className="text-sm font-bold">
        {title}
      </p>

      <p className="mt-1 text-xs leading-5 text-slate-500">
        {text}
      </p>
    </div>
  );
}